import React from 'react';
import './index.module.less';
import NavBar from '@components/NavBar';
import ImageScan from './ImageScan';
import QrcodeScan from './QrcodeScan';
import Http from '@helpers/Http';
import { Api } from '@apis/client';
import Toast from '@widgets/Toast';
import Filter from '@helpers/Filter';
import userStore from '@stores/user';
import ConfirmModal from '@views/components/ConfirmModal';
import BrowserHistory, {pushAndPopUntil}  from '@helpers/BrowserHistory';
import * as Cache from '../../../../../app/helpers/Cache';
import { deviceStatus } from '@helpers/Constants';

const BindStatus = {
  NOT_BIND: 0,
  BIND_SELF: 1,
  BIND_OTHER: 2
}

const getBindStatus = (data: any) => {
  if (!data || !data.ownerUid || data.ownerUid.length <= 0) {
    return BindStatus.NOT_BIND;
  }
  if (data.ownerUid === userStore.userInfo.uid) {
    return BindStatus.BIND_SELF;
  } else {
    return BindStatus.BIND_OTHER;
  }
}

const DeviceQrcodeScan = () => {
  const qrcodeScanRef = React.useRef(null);

  const handleResume = () => {
    // 恢复扫码
    qrcodeScanRef.current?.resume();
  }
  
  const handleScan = async (scanData: string) => {
    // parse scanData
    const params = Filter.urlParams(scanData);
    if(!params || !params.i || !params.c || !params.s) {
      Toast.show({
        type: 'strip',
        title: '无法识别二维码'
      });
      handleResume();
      return;
    }
    try {
      // 先判断是否已锁定
      const { data } = await Http.post(
        Api.GetCardInfoBySncode,
        { snCode: params.i, company: 'lingge' }
      )

      if (data?.status === deviceStatus.forbid) {
        ConfirmModal.show({
          title: '设备已禁用',
          text: '设备已被服务商禁用，请联系服务商解除。',
          confirmBtnText: '我知道了',
          confirmBtnStyle: { backgroundColor: '#F2F4F7', color: '#55585C' },
        });
        handleResume();
      } else if (data?.status === 3) {
        ConfirmModal.show({
          title: '设备已锁定',
          text: '设备插入的SIM卡不是服务商提供，因此设备已被锁定，解锁请插入服务商提供的SIM卡，并确认SIM卡可正常使用。',
          confirmBtnText: '我知道了',
        });
        handleResume();
      } else {
        // 判断是否已绑定
        const { data } = await Http.post(
          Api.GetDeviceBindInfo,
          { snCode: params.i, company: 'lingge' }
        )
        const bindStatus = getBindStatus(data)
  
        switch(bindStatus) {
          case BindStatus.NOT_BIND: {
            BrowserHistory.push(`${PUBLIC_URL}/devicesetphone?sncode=${params.i}&company=lingge&version=${ params.v || '1'}&rfid=${params.c}&secretCode=${params.s}`);
            break;
          }
          case BindStatus.BIND_SELF: {
            Toast.show({
              type: 'strip',
              title: '您已绑定该设备'
            });
            pushAndPopUntil(`${PUBLIC_URL}/myDevices?selectedDeviceSN=${params.i}`, ['/myDevices', '/']);
            break;
          }
          case BindStatus.BIND_OTHER: {
            // 被其他人绑定，但没有关联孩子，提示"该设备绑定人数已达上限"
            if (!data.bindUserUid || data.bindUserUid.length <= 0) {
              Toast.show({
                type: 'strip',
                title: '该设备绑定人数已达上限'
              });
              handleResume();
              break;
            }
  
            // 有关联孩子
            const result = await Http.post(
              Api.GetDeviceDetailInfo,
              { snCode: params.i, company: 'lingge' }
            )
            if (result && result?.data) {
              const checkSelfInUsers = result?.data?.users.filter((user: any) => user.userUid === userStore.userInfo.uid);
              if(checkSelfInUsers.length > 0) {
                Toast.show({
                  type: 'strip',
                  title: '您已绑定该设备'
                });
                pushAndPopUntil(`${PUBLIC_URL}/myDevices?selectedDeviceSN=${params.i}`, ['/myDevices', '/']);
                break;
              }
              if(result.data.users.length >= 10) {
                Toast.show({
                  type: 'strip',
                  title: '该设备绑定人数已达上限'
                });
                handleResume();
                break;
              } else {
                // 绑定还有坑位，判断是否在3天内申请过
                const applicantInfo = await Http.post(
                  Api.GetApplicantInfo,
                  { applicantUid: userStore.userInfo.uid, targetUid: data.bindUserUid, targetType: 0 }
                )
                Cache.save('deviceBindInfo', data);
                Cache.save('lastApplyInfo', applicantInfo?.data);
                if (!applicantInfo?.data
                  || applicantInfo?.data?.approvalResult === 1
                  || Date.now() - applicantInfo?.data.applyTime > 3 * 24 * 3600 * 1000)  {
                    // 没有申请或时间大于3天, 进入申请绑定页
                    pushAndPopUntil(`${PUBLIC_URL}/devicebindapply`, ['/devicebindapply', '/']);
                } else {
                  pushAndPopUntil(`${PUBLIC_URL}/devicebindresult?type=${applicantInfo?.data?.approvalResult}`, ['/devicebindresult', '/']);
                }
              }
            } else {
              handleResume();
            }
            break;
          }
          default: {
            Toast.show({
              type: 'strip',
              title: '请求出错，请稍后重试'
            });
            handleResume();
            break;
          }
        }
      }
    } catch (error) {
      handleResume();
    }
  }

  return (
    <div styleName="container">
      <NavBar
        title="扫一扫"
        transparent
        styleName="nav-bar"
        RightBtnComponent={
          <div styleName="nav-right-btn">
            <ImageScan onScan={handleScan}/>
          </div>
        }
      />
      <QrcodeScan ref={qrcodeScanRef} onScan={handleScan}/>
    </div>
  )
}

export default DeviceQrcodeScan;
